var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAssuredGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 65 68",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "85.7730645%",
  y1: "19.2774666%",
  x2: "26.704471%",
  y2: "87.2072059%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8B958",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6A644",
  offset: "100%"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-2",
  transform: "translate(17.000000, 17.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 31,
  height: 33
})), /*#__PURE__*/React.createElement("g", {
  id: "assured",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.3238355,0 L34.6890225,2.072753 C41.2188233,7.795203 45.3487194,9.1102228 53.1421028,9.6220495 C61.7523737,10.1875249 64.6473298,13.4015072 64.6473298,24.9531822 C64.6473298,38.9628414 59.8555643,49.8142434 51.6325024,57.5326995 C45.7787268,63.0272599 38.4480479,66.5208478 32.9128408,67.4420502 L32.3247246,67.539928 L31.7365515,67.4423928 C26.1924425,66.523028 18.8593728,63.0296047 13.0052407,57.5321225 C4.7877172,49.8152335 0,38.9636783 0,24.9531822 C0,13.4011697 2.8950404,10.1869918 11.5056525,9.6210745 C19.2992992,9.1088509 23.4289582,7.7939816 29.9585003,2.0725839 L32.3238355,0 Z M35.3269304,21.294033 L29.5693313,21.294033 L19.5317472,45.9039474 L25.238394,45.9039474 L27.669,39.661 L37.175,39.661 L39.6069155,45.9039474 L45.3645145,45.9039474 L35.3269304,21.294033 Z M32.4226548,27.4592497 L35.675,35.81 L29.169,35.81 L32.4226548,27.4592497 Z",
  id: "Forma_1_copy_3"
})))));
export default SvgAssuredGradient;